<template>
	<div class="flex" style="flex-direction: column; height: 100%">
		<sm-card title="筛选查询" noHeader icon="el-icon-search" style="height: 80px">
			<el-form slot="body" class="flex" inline ref="form" :model="searchParm" label-width="120px">
				<el-row class="flex-1">
					<el-col :span="6">
						<el-form-item label="查看企业：">
							<el-select v-model="searchParm.entId" clearable :popper-append-to-body="false" placeholder="请选择">
								<el-option v-for="item in ents" :key="item.abbr" :label="item.abbr" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
					    <el-form-item label="绑定状态：">
					        <el-radio-group v-model="searchParm.bangdingStatus" @input="list()">
					            <el-radio :label="0">已绑定</el-radio>
					            <el-radio :label="1">未绑定</el-radio>
					        </el-radio-group>
					    </el-form-item>
					</el-col>
				</el-row>
				<div>
					<el-button type="primary" @click="list()">查询</el-button>
					<el-button plain @click="clearSearch()">重置</el-button>
				</div>
			</el-form>
		</sm-card>
		<div class="tableModule">
			<div class="title">
				<div class="title-left">
					<i class="el-icon-s-operation"></i>
					<span>数据列表</span>
				</div>
				<div class="title-right"><el-button type="primary" size="medium" @click="insert()" style="margin-right: 8px">新增绑定</el-button></div>
				<!-- <div class="title-right"><el-button type="primary" size="medium" @click="add()" style="margin-right: 8px">新增wincc测点</el-button></div> -->
			</div>
			<div class="tableContainer">
				<div class="table" ref="tableContainer">
					<div>
						<el-table
							ref="usertable"
							:data="tableData.records"
							border
							:height="tableHeight"
							:header-cell-style="{ 'background-color': '#f9fafc' }"
							:cell-style="{ padding: 0 }"
							style="margin-bottom: 20px"
						>
							<el-table-column prop="id" align="center" label="绑定id" show-overflow-tooltip></el-table-column>
							<el-table-column prop="create_time" align="center" label="绑定时间" show-overflow-tooltip></el-table-column>
							<el-table-column prop="create_user" align="center" label="绑定账号" show-overflow-tooltip></el-table-column>
							<el-table-column prop="entName" align="center" label="企业名称" show-overflow-tooltip></el-table-column>
							<el-table-column prop="measId" align="center" label="测点id" show-overflow-tooltip></el-table-column>
							<el-table-column prop="measName" align="center" label="测点名称" show-overflow-tooltip></el-table-column>
							
							<el-table-column align="center" label="测点类型" show-overflow-tooltip>
								<template slot-scope="scope">
									<div>{{ scope.row.type==1?'温度':'振动' }}</div>
								</template>
							</el-table-column>
							
							<el-table-column prop="rzId" align="center" label="容知id" show-overflow-tooltip></el-table-column>
							<el-table-column prop="path" align="center" label="容知路径" show-overflow-tooltip></el-table-column>
							<el-table-column fixed="right" align="center" label="操作" width="230">
								<template slot-scope="scope">
									<!-- <el-button type="text" @click="editName(scope.row)">编辑</el-button> -->
									<el-button v-if="searchParm.bangdingStatus != 1" type="text"
									    @click="remove(scope.row)">解除绑定</el-button>
									<el-button v-if="searchParm.bangdingStatus == 1" type="text"
									    @click="insert(scope.row)">去绑定</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="pagination">
					<el-pagination
						style="float: right"
						@current-change="handleCurrentChange"
						:current-page.sync="searchParm.page"
						:page-size="searchParm.pageSize"
						layout="total, prev, pager, next,jumper"
						:total="tableData.total"
					></el-pagination>
				</div>
			</div>
		</div>
		<insert :isShow.sync="showInsertDialog" :dialogObj="insertObj"></insert>
		<addWincc :isShow.sync="showAddDialog" :dialogObj="addObj"></addWincc>
	</div>
</template>
<script>
import smCard from '@c/smCard.vue';
import insert from './insert.vue';
import addWincc from './add.vue';
export default {
	components: {
		smCard,
		insert,
		addWincc
	},
	data() {
		return {
			tableHeight: 0,
			tableData: {
				records: []
			},
			searchParm: {
				pageSize: 20,
				page: 1
			},
			showInsertDialog: false,
			insertObj: {},
			showAddDialog:false,
			addObj: {},
			showEditDialog: false,
			editObj: {},
			showCopyInsertDialog: false,
			copyInsertObj: {},

			ents: []
		};
	},
	created() {
		this.getEnts();
	},
	methods: {
		//自适应表格高度
		calHeight() {
			this.$nextTick(() => {
				const rect = this.$refs.tableContainer.getBoundingClientRect();
				this.tableHeight = rect.height;
			});
		},
		//获取企业列表
		getEnts() {
			this.$get('/backend-api/sys/ent/list', {
				size: 99
			}).then(res => {
				if (res.code == 1000) {
					this.ents = res.data.records;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		//清空搜索
		clearSearch() {
			this.searchParm = {
				pageSize: 20,
				page: 1
			};
			this.list();
		},
		//列表数据
		list() {
			this.$get('/backend-api/eqp/set/unit/meas/rongzi/list', this.searchParm).then(res => {
				if (res.code == 1000) {
					this.tableData = res.data;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		//打开新增弹窗
		insert(row) {
			if (row) {
			    let obj = {
			        type:3,
			    }
			    this.insertObj = {...row,...obj}
			} else {
			    this.insertObj['type'] = 1;
			}
			this.showInsertDialog = true;
		},
		//打开新增弹窗
		editName(row) {
			this.insertObj['row'] = row;
			this.insertObj['type'] = 2;
			this.showInsertDialog = true;
		},
		//打开编辑弹窗
		edit(row) {
			this.editObj = row;
			this.showEditDialog = true;
		},
		//分页选择页面回调
		handleCurrentChange(val) {
			this.searchParm.page = val;
			this.list();
		},
		
		//打开新增wincc测点
		add() {
			this.addObj['type'] = 1;
			this.showAddDialog = true;
		},
		
		//删除
		remove(row) {
			this.$confirm('是否确认删除？', '删除绑定', {
				dangerouslyUseHTMLString: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$post('/backend-api/eqp/set/unit/meas/rongzi/delete', {
						id: row.id
					}).then(res => {
						if (res.code == 1000) {
							this.$message.success(res.msg);
							//刷新表格
							this.list();
						} else {
							this.$message.error(res.msg);
						}
					});
				})
				.catch(() => {});
		}
	},
	mounted() {
		this.list();
		this.calHeight();
		window.addEventListener('resize', this.calHeight);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.calHeight);
	}
};
</script>
<style lang="scss" scoped>
@import '@style/userCenter.scss';
</style>
